export class BookingInformation {
  sourceLocation: string;
  startDateTime: string;
  endDateTime: string;
  bookingReferenceID: string;
  recurringID: string;
  bookingStatus: string;
  externalId: string;
  translatedBookingStatus : string;
  translatedBookingType : string;
  booingType: string;
  bookingRemarks: string;
  adminRemarks: string;
  licenceTag: string;
  vehicleOwner: string;
  sharedVehicleGroup: string;
  type: string;
  vehicleClass: string;
  bodyStyle: string;
  // airco: boolean;
  // towbar: boolean;
  isAnyRunningBooking: boolean;
  fuelType: string;
  brand: string;
  color: string;
  pricingCategory: string;
  attributeList: string[];
  licenceNumber: string;
  driverName: string;
  bookingCustomFee: string;
  vehicleHashId: string;
  sharedVehicleGroupHashId: string;
  invoiceDetail: InvoiceDetail;
  listOfBookingTrip: BookingTripDetail[];
  listOfVehicleRequest: VehicleRequest[];
  ListOfBookingExpense: Expense[];
  allowedStartDateTime: string;
  isGroupedTrip: boolean;
  prePostTripInformation: PrePostTripDetails[];
  organizationName: string;
  isVehicleDeleted:boolean;
  isSharedVehicleGroupDeleted:boolean;
  isDriverInvoiceVisible:boolean;
  isOrganizationInvoiceVisible:boolean;

  constructor() {
    this.invoiceDetail = new InvoiceDetail();
  }
}

export class PrePostTripDetails{
  question: string;
  questionType: string;
  answer: string;
  answerDateTime: string;
  answerId: number;
  remark: string;
}
export class InvoiceDetail {
  totalExpense: string;
  totalKm: string;
  totalHours: string;
  freeHours: string;
  freeKm: string;
  hourlyRate: string;
  mileageRate: string;
  fixedFree: string;
  processingFree: string;
  plateFormCostUsage: string;
  vat: string;
  invoiceDate: string;
  invoiceNumber: string;
  currencySymbol: string;
  isCurrencySymbolBefore :boolean;
  grandTotal: string;
  status: string;
  additionalFreeKm: string;
  additionalFreeHours: string;
  additionalFreeHoursFormat: string;
  totalHoursFormat: string;
  freeHoursFormat: string;
  penaltyRate: string;
  organizationInvoiceDate: string;
  organizationInvoiceNumber: string;
}
export class BookingTripDetail {
  id: string;
  distance: string;
  endDateTime: string;
  startDateTime: string;
  contractTypeGroup: string;
  contractTypeGroupId: string;
  bookingTripHashId: string;
  contractTypeGroupHashId: string = "";
  BookingHashId: string;
}
export class VehicleRequest {
  requestType: string;
  result: string;
  timeDifference: string;
  requestDateTime: string;
  processDateTime: string;
  resultDateTime: string;
}
export class Expense {
  bookingExpenseHashId: string;
  expenseName: string;
  amount: string;
  amountVat: string;
  description: string;
  damageImagePath: string;
  currencySymbol: string;
  isCurrencySymbolBefore :boolean;
  costTypeHashId: string;
  costTypeName: string;
  receiptPath: string;
  reportedAmountExVatFormat: string;
  reportedAmountVatFormat: string;
  reportedAmountExVat: number;
  reportedAmountVat: number;
  status: string;
  reportedVatPercentage: number;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking/models/booking-information.model.ts